import dayjs from "dayjs";
import { XIcon } from "lucide-react";
import { useEffect, useState } from "react";
import { zIndex } from "styles/zIndex";

const link = "https://support.mix.day/dee2c9ae-495a-4672-8aa2-3fcc9d5feb77";

export const TopBanner = ({
    text,
    url,
    endDate
}: {
    text: string | undefined;
    url: string | undefined;
    endDate: string | undefined;
}) => {
    const [isTopBannerOpen, setIsTopBannerOpen] = useState(false);

    useEffect(() => {
        // Guard against SSR
        if (typeof document === "undefined") return;

        // If no banner data, don't show
        if (!text || !endDate) {
            setIsTopBannerOpen(false);
            return;
        }

        // Generate a unique banner ID based on endDate for this specific banner
        const bannerId = endDate;
        const localStorageKey = `mix/topbanner-closed-${bannerId}`;

        // Check localStorage (works in both web and extension)
        const closedInLocalStorage =
            localStorage.getItem(localStorageKey) === "true";

        // Check date range
        // If the banner is past its end date, don't show it
        const inRange = !dayjs().isAfter(endDate, "day");

        // Show banner only if:
        // 1. not closed in localStorage
        // 2. within date range
        // Note: is_active filtering is handled by the GraphQL query
        if (!closedInLocalStorage && inRange) {
            setIsTopBannerOpen(true);
        }
    }, [endDate, text]);

    const handleCloseButtonClick = () => {
        // Generate the same banner ID
        const bannerId = endDate;
        const localStorageKey = `mix/topbanner-closed-${bannerId}`;

        // Store close state in localStorage (works in both web and extension)
        localStorage.setItem(localStorageKey, "true");

        setIsTopBannerOpen(false);
    };

    return isTopBannerOpen ? (
        <div className="flex items-center justify-end bg-[#343862] px-4">
            <a
                href={url || link}
                target="_blank"
                rel="noreferrer"
                className="relative flex h-16 w-full items-center
                    overflow-hidden bg-[#343862] bg-[length:580px] bg-center
                    bg-no-repeat text-[16px] text-white md:h-[70px] md:justify-center
                    md:bg-[length:280px]"
                style={{ zIndex: zIndex.header }}
            >
                <div className="banner-scroll-content flex whitespace-nowrap">
                    <span
                        className="banner-content-item inline-block"
                        dangerouslySetInnerHTML={{ __html: text || "" }}
                    />
                    <span
                        className="banner-content-duplicate inline-block"
                        aria-hidden="true"
                        dangerouslySetInnerHTML={{ __html: text || "" }}
                    />
                </div>
            </a>
            <XIcon
                className="m-4 mr-3 size-6 cursor-pointer p-0.5 text-white"
                onClick={handleCloseButtonClick}
            />
        </div>
    ) : (
        <></>
    );
};
